export default "__VITE_ASSET__BmzYM7rV__"